


































import VTextFieldWithValidation from '@/components/VTextFieldWithValidation.vue';
import { IBlacklistAddress, IBlacklistAddressUpdate } from '@/interfaces';
import { dispatchGetBlacklistAddress, dispatchUpdateBlacklistAddress } from '@/store/main/accessors';
import { format, parseISO } from 'date-fns';
import { ValidationProvider } from 'vee-validate';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    VTextFieldWithValidation,
  },
})
export default class EditBlacklistAddress extends Vue {
  public valid = false;
  public blacklistAddress: IBlacklistAddress = {} as IBlacklistAddress;
  public $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };

  public get date() {
    return format(parseISO(this.blacklistAddress.date), `yyyy-MM-dd kk:mm`);
  }

  public async mounted() {
    this.blacklistAddress = await dispatchGetBlacklistAddress(this.$store, {
      id: Number(this.$router.currentRoute.params.id),
      addressId: Number(this.$router.currentRoute.params.addressId),
    });
  }

  public async reset() {
    this.blacklistAddress = {} as IBlacklistAddress;
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if (await this.$refs.observer.validate()) {
      const address: IBlacklistAddressUpdate = {
        commentary: this.blacklistAddress.commentary,
        selfban: this.blacklistAddress.selfban,
      };
      const result = await dispatchUpdateBlacklistAddress(this.$store, {
        id: Number(this.$router.currentRoute.params.id),
        addressId: Number(this.$router.currentRoute.params.addressId),
        payload: address,
      });
      if (result) {
        this.$router.push({ name: 'main-blacklist-addresses-all' });
      }
    }
  }
}
